export * from './generated/constants';

export const BASE_LOCALE = 'en';
